<template>
  <div class="add-banner">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span class="title">{{ title }}</span>
      </div>
      <div>
        <el-form ref="form" :model="form" label-width="150px" :rules="rules">
          <el-form-item label="Banner名称：" prop="name">
            <el-input
              v-model="form.name"
              placeholder="请输入2-18字名称"
              class="input-width"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="Banner位置：" prop="advertMark">
            <el-select v-model="form.advertMark" placeholder="请选择Banner位置" class="input-width">
              <el-option
                v-for="item in positionList"
                :key="item.key"
                :value="Number(item.key)"
                :label="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="序号：" prop="weight">
            <el-input
              v-model.number="form.weight"
              placeholder="请输入序号"
              class="input-width"
              oninput="value=value.replace(/[^\d]/g,'')"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="banner链接：" prop="linkUrl">
            <el-input
              v-model="form.linkUrl"
              placeholder="请输入链接地址"
              class="input-width"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="链接板块：" prop="jumpModule">
            <el-select
              v-model="form.jumpModule"
              placeholder="请选择链接模块"
              class="input-width"
              clearable
            >
              <el-option label="课程详情模块" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="内链：" prop="insideLinkUrl">
            <el-input
              v-model="form.insideLinkUrl"
              placeholder="请输入内链接"
              class="input-width"
              clearable
            ></el-input>
            <span class="inner-link-tips">*机构ID-商品ID, 示例: 1597--6515</span>
          </el-form-item>
          <el-form-item label="开始时间:" prop="startTime" clearable>
            <el-date-picker
              v-model="form.startTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期"
              clearable
              :picker-options="pickerOptionsStart"
              @change="startTimeStatus"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="到期时间:" prop="endTime">
            <el-date-picker
              v-model="form.endTime"
              type="datetime"
              clearable
              :picker-options="pickerOptionsEnd"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期"
              @change="endTimeStatus"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="上线/下线：">
            <el-radio-group v-model="form.status">
              <el-radio :label="false">下线</el-radio>
              <el-radio :label="true">上线</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item ref="imgUrl" label="上传图片：" prop="imgUrl">
            <upload-image v-model="form.imgUrl" :upload-img="$refs.imgUrl"></upload-image>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" class="submit" @click="handleSubmit('form')">
              确认添加
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import to from 'await-to'
import { bannerPlatformFilter, bannerAdd, bannerInfo, bannerEdit } from '@/api/system'
import UploadImage from '@/components/UploadImage.vue'

export default {
  name: 'AddBanner',
  components: {
    UploadImage,
  },
  data() {
    var validateImg = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请上传图片'))
      } else {
        callback()
      }
    }
    return {
      title: '添加banner',
      form: {
        name: '',
        advertMark: '',
        weight: '',
        linkUrl: '',
        jumpModule: '',
        insideLinkUrl: '',
        startTime: '',
        endTime: '',
        status: 0,
        imgUrl: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入Banner名称', trigger: 'blur' },
          { min: 2, max: 18, message: '请输入2-18字名称', trigger: 'blur' },
        ],
        advertMark: [{ required: true, message: '请选择Banner位置', trigger: 'change' }],
        weight: [{ required: true, message: '请输入序号', trigger: 'blur' }],
        imgUrl: [{ required: true, validator: validateImg, trigger: 'change' }],
      },
      positionList: [],
      pickerOptionsStart: {
        // 禁止选择
        disabledDate: time => {
          let endDateVal = this.form.endTime
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime()
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.form.startTime
          if (beginDateVal) {
            return time.getTime() < new Date(beginDateVal).getTime()
          }
        },
      },
      id: this.$route.params.id,
    }
  },
  mounted() {
    this.getPositionList()
    if (this.id) {
      this.title = '编辑banner'
      this.handleGetBannerInfo(this.id)
    }
  },
  methods: {
    async getPositionList() {
      const [res, err] = await to(bannerPlatformFilter({}))
      if (err) return this.$message.warning(err.msg)
      this.positionList = res.data
    },
    startTimeStatus(time) {
      this.form.startTime = time
    },
    endTimeStatus(time) {
      this.form.endTime = time
    },
    async handleGetBannerInfo(id) {
      const [res, err] = await to(bannerInfo({ id }))
      if (err) return this.$message.warning(err.msg)
      this.form = res.data
      if (this.form && this.form.markList.length > 0) {
        this.$set(this.form, 'advertMark', Number(res.data.markList[0]))
      }
    },
    async handleSubmit(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          if (this.form.advertMark) {
            this.$set(this.form, 'markList', [this.form.advertMark])
          }
          if (this.id) {
            const [, err] = await to(bannerEdit(this.form))
            if (err) return this.$message.warning(err.msg)
            this.$message.success('编辑成功')
            this.$router.push('/college/banner')
          } else {
            const [, err] = await to(bannerAdd(this.form))
            if (err) return this.$message.warning(err.msg)
            this.$message.success('添加成功')
            this.$router.push('/college/banner')
          }
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.add-banner {
  .box-card {
    margin-top: 30px;
    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .title {
        font-size: 18px;
      }
      .tips {
        font-size: 14px;
        color: #999;
      }
    }
    .input-width {
      width: 350px;
    }
    .inner-link-tips {
      display: block;
      margin-top: 8px;
      font-size: 12px;
      color: #f56c6c;
    }
    .status-text {
      margin-left: 8px;
      font-size: 14px;
      color: #409eff;
    }
    ::v-deep .uploader {
      height: 92px !important;
      .el-upload {
        width: 180px;
        height: 100%;
        background: #f5f5f5;
        border-radius: 5px;
      }
      .el-upload-list__item {
        width: 180px;
        height: 100%;
      }
    }
    .el-upload-list__item {
      width: 180px;
      height: 100%;
    }
    .upload-tips {
      display: block;
      margin-top: 8px;
      font-size: 12px;
      color: #999;
    }
    .submit {
      width: 200px;
      height: 40px;
      font-size: 16px;
    }
  }
}
</style>
